module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.getOuterClass(),
    on: {
      "click": _vm.click
    }
  }, [_vm._t("icon"), _vm._v(" "), _c('div', {
    staticClass: "contentarea",
    style: ({
      'margin-left': _vm.$slots.icon ? '10pt' : '0'
    })
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.nameString))]), _vm._v(" "), _vm._t("balance")], 2), _vm._v(" "), _c('i', {
    staticClass: "icon",
    class: _vm.name === _vm.value ? 'radio-icon-active' : 'radio-icon'
  }, [_vm._v("")])], 2), _vm._v(" "), _c('div', {
    staticClass: "bottom-divide"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ba0e6a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/radio.vue
// module id = 829
// module chunks = 34